// Is this listing finished, and was it a sale or a rental?
//
// Marking a rental "Leased" reuses the sale plumbing rather than adding parallel
// fields and a migration: it sets is_sold=true on a transaction_type='lease'
// property (see components/common/leaseUpdate.js). So is_sold really means "this
// listing is finished", and a leased rental satisfied every Sold filter in the
// CRM - which is how leased rentals ended up filling the Sold tab. Christian
// Gravias, 24 Sep 2026: "Leased properties going under Sold. Create a new tab
// Leased."
//
// These helpers are the single place that split the finished state by
// transaction type, so the My Listings and Collings Properties tab bars (which
// already share PropertyFilterTabs) can't drift apart on it either. They accept
// both row shapes those pages see: a CRM property, and one whose status/flags
// arrive nested under extra_info.

const readStatusName = (property) =>
    (property?.status?.name || property?.status || property?.extra_info?.status || "")
        .toString()
        .toLowerCase();

// A rental. `transaction_type` is the CRM's own field; property_type is the
// fallback for rows that only carry the looser category string.
export const isLeaseListing = (property) => {
    const transactionType = (property?.transaction_type || property?.extra_info?.transaction_type || "")
        .toString()
        .toLowerCase();
    if (transactionType) return transactionType === "lease";
    return (property?.property_type || "").toString().toLowerCase().includes("lease");
};

// Sold OR leased - the shared "this listing is done" flag. On Market / Off
// Market exclude this, not just the sold half, so a leased rental doesn't fall
// back into an active tab now that Sold no longer claims it.
export const isCompletedListing = (property) =>
    Boolean(property?.is_sold || property?.extra_info?.is_sold || readStatusName(property) === "sold");

export const isSoldListing = (property) =>
    isCompletedListing(property) && !isLeaseListing(property);

export const isLeasedListing = (property) =>
    isCompletedListing(property) && isLeaseListing(property);
